import uuidv4 from 'uuid/v4';

import {
    ATTEMPT_FETCH_PROGRAM,
    ATTEMPT_FETCH_EXERCISES,

    DRAFT_CREATE_PROGRAM,
    ATTEMPT_CREATE_PROGRAM,

    DRAFT_CREATE_MICROCYCLE,
    ATTEMPT_CREATE_MICROCYCLE,

    FETCH_ORGANIZATION_SETTINGS_ATTEMPT,
    ATTEMPT_UPDATE_PROGRAM_SHARING,
    ATTEMPT_UPDATE_PROGRAM_CONTACT_EMAIL,
} from 'shared_redux/actions';

export const fetchProgram = (program_id) => ({
    type: ATTEMPT_FETCH_PROGRAM,
    program_id,
});

export const fetchExercises = () => ({ type: ATTEMPT_FETCH_EXERCISES });

export const fetchSettings = () => ({ type: FETCH_ORGANIZATION_SETTINGS_ATTEMPT });

export const createProgram = (id) => {
    return {
        type: DRAFT_CREATE_PROGRAM,
        pushType: ATTEMPT_CREATE_PROGRAM,
        payload: {
            id,
            name: 'New Program',
            microcycle_name: 'Week',
        },
    };
};

export const createMicrocycle = (program_id, order) => {
    const id = uuidv4();
    return {
        type: DRAFT_CREATE_MICROCYCLE,
        pushType: ATTEMPT_CREATE_MICROCYCLE,
        payload: {
            id,
            program_id,
            order,
        },
    };
};

export const updateProgramSharing = (program_id, is_public) => ({
    type: ATTEMPT_UPDATE_PROGRAM_SHARING,
    program_id,
    is_public,
});

export const updateProgramContactEmail = (program_id, contact_email) => ({
    type: ATTEMPT_UPDATE_PROGRAM_CONTACT_EMAIL,
    program_id,
    contact_email,
});

export const fetchProgramUsers = (program_id) => ({
    type: 'FETCH_PROGRAM_USERS',
    program_id,
});

export const fetchAthleteEmail = (program_id, athlete_id) => ({
    type: 'FETCH_ATHLETE_EMAIL',
    program_id,
    athlete_id,
});
